module.exports = __webpack_public_path__ + "img/wzjs2.741ae91e.jpg";